import {
    Accordion,
    AccordionTitle,
    AccordionTitleItem,
} from 'components/Accordion';
import ClusterFilterAccordionItem, {
    ClusterHelpLink,
} from 'components/ClusterFilterAccordionItem';
import HealthStatFilterAccordionItem, {
    PriceHealthStatFilterOption,
} from 'components/HealthStatFilterAccordionItem';
import { MetricIcon } from 'components/HealthStats';
import PresetFilterAccordionItem from 'components/Accordion/PresetFilterAccordionItem/GooglePresetFilterAccordionItem';
import { RemoveFilterButton } from 'components/Button/FilterButton';
import { healthStatFilterOptions } from 'utils/filters';
import { useState } from 'react';

function CardsFilterAccordion({
    filters,
    setFilter,
    resetFilters,
    healthStatKeys,
    mixpanelMeta,
}) {
    const [active, setActive] = useState('cluster');
    const totalActiveFilters = Object.entries(filters).reduce(
        (acc, [key, value]) =>
            key !== 'name' && value ? [...acc, ...value] : acc,
        [],
    ).length;

    const getOnChange =
        (filterKey) =>
        ({ action, option }) => {
            switch (action) {
                case 'select-option':
                    setFilter(filterKey, [
                        ...(filters[filterKey] || []),
                        option,
                    ]);
                    break;
                case 'remove-value':
                    setFilter(
                        filterKey,
                        filters[filterKey].filter(
                            ({ value }) => value !== option.value,
                        ),
                    );
                    break;
                default:
                    throw new Error(`Unexpected action type "${action}"`);
            }
        };

    const filteredHealthStatFilterOptions = healthStatKeys
        ? healthStatFilterOptions.filter(({ label }) =>
              healthStatKeys.includes(label),
          )
        : healthStatFilterOptions;

    return (
        <Accordion $isActive={totalActiveFilters > 0 || !!active}>
            <AccordionTitleItem>
                <AccordionTitle>filters</AccordionTitle>
                {totalActiveFilters > 0 ? (
                    <RemoveFilterButton
                        onClick={(e) => resetFilters()}
                        css={`
                            margin-left: ${({ theme }) => theme.space_5}px;
                        `}
                    >
                        {totalActiveFilters} Filter
                        {totalActiveFilters > 1 ? 's' : null}
                    </RemoveFilterButton>
                ) : null}
            </AccordionTitleItem>
            <ClusterFilterAccordionItem
                isOpen={active === 'cluster'}
                toggleOpen={() =>
                    setActive(active === 'cluster' ? null : 'cluster')
                }
                appliedFilters={
                    filters.cluster
                        ? filters.cluster.map(({ value }) => value)
                        : null
                }
                onChange={getOnChange('cluster')}
                mixpanelMeta={mixpanelMeta}
                panelId="cards-filter-clusters"
            >
                <ClusterHelpLink
                    href="https://help.spate.nyc/en/article/clusters-explained"
                    target="_blank"
                    rel="noopener noreferrer"
                    mixpanelContext="CLUSTERS_HELP"
                >
                    What are clusters?
                </ClusterHelpLink>
            </ClusterFilterAccordionItem>
            {filteredHealthStatFilterOptions.map(
                ({
                    label,
                    filter: filterKey,
                    options,
                    panelId,
                    abbrTitleHTML,
                }) => (
                    <HealthStatFilterAccordionItem
                        isOpen={active === label}
                        toggleOpen={() =>
                            setActive(active === label ? null : label)
                        }
                        appliedFilters={
                            filters[filterKey]
                                ? filters[filterKey]
                                      .filter(({ value }) =>
                                          options.some(
                                              ({ value: optionValue }) =>
                                                  value === optionValue,
                                          ),
                                      )
                                      .map(({ value }) => value)
                                : null
                        }
                        onChange={getOnChange(filterKey)}
                        label={label}
                        panelId={`cards-filter-health-stats-${panelId}`}
                        abbrTitleHTML={abbrTitleHTML}
                        options={options}
                        Icon={() => <MetricIcon metricLabel={label} />}
                        mixpanelMeta={mixpanelMeta}
                        key={label}
                        {...(label === 'price point' && {
                            FilterOption: PriceHealthStatFilterOption,
                        })}
                    />
                ),
            )}
        </Accordion>
    );
}

export default CardsFilterAccordion;
